var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',[_c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"平台券管理","name":"first"}},[_c('consumer-coupons-manager')],1),_c('el-tab-pane',{attrs:{"label":"商家接劵审核","name":"second"}},[_c('consumer-coupons-apply')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }